<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="main-box">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="content-box">
                            <div class="content-header">
                                <h1 class="content-title">{{$t('meta.faq.h1')}}</h1>
                                <span class="content-subtitle">Lorem psum sakiniais kaip pasietki aukscia</span>
                                <div class="search-box">
                                    <div class="input-group input-group-lg">
                                        <input type="text" class="form-control" aria-label="Large" aria-describedby="inputGroup-sizing-sm">
                                    </div>
                                </div>
                                <ul class="list-box">
                                    <div class="row">
                                        <li class="col-sm-4 col-xs-12">
                                            <a href="#" class="card">
                                                <div class="card-body">
                                                    <img src="~img/help-page-nav-icon-1.png" :alt="$t('meta.faq.h1')"  :title="$t('meta.faq.h1')">
                                                    <span class="card-title">Kas yra boxiti?</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col-sm-4 col-xs-12">
                                            <a href="#" class="card">
                                                <div class="card-body">
                                                    <img src="~img/help-page-nav-icon-2.png" :alt="$t('meta.faq.h1')"  :title="$t('meta.faq.h1')">
                                                    <span class="card-title">Inventorius</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col-sm-4 col-xs-12">
                                            <a href="#" class="card">
                                                <div class="card-body">
                                                    <img src="~img/help-page-nav-icon-3.png" :alt="$t('meta.faq.h1')"  :title="$t('meta.faq.h1')">
                                                    <span class="card-title">Sandeliavimas</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col-sm-4 col-xs-12">
                                            <a href="#" class="card">
                                                <div class="card-body">
                                                    <img src="~img/help-page-nav-icon-4.png" :alt="$t('meta.faq.h1')"  :title="$t('meta.faq.h1')">
                                                    <span class="card-title">Užsakymai</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col-sm-4 col-xs-12">
                                            <a href="#" class="card">
                                                <div class="card-body">
                                                    <img src="~img/help-page-nav-icon-5.png" :alt="$t('meta.faq.h1')"  :title="$t('meta.faq.h1')">
                                                    <span class="card-title">Pristatymo paslaugos</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col-sm-4 col-xs-12">
                                            <a href="#" class="card">
                                                <div class="card-body">
                                                    <img src="~img/help-page-nav-icon-6.png" :alt="$t('meta.faq.h1')"  :title="$t('meta.faq.h1')">
                                                    <span class="card-title">Kaina ir apmokėjimas</span>
                                                </div>
                                            </a>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                            <div class="content-description">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="card-title">Kas yra boxiti?</h2>
                                                <ul>
                                                    <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                                    <li>Kokias paslaugas teikiate?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long
                                                        term contracts. You are free to close your account at any time; all we ask is 30 days notice for
                                                        inventory retrieval.
                                                    </li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Ar priimate grąžinimus iš klientų?</li>
                                                    <li>Kokias papildomas paslaugas teikiate? Prekių žymėjimas lipdukais?</li>
                                                    <li>Ar galite pridėti mano PVM sąskaitą-faktūrą prie užsakymo?</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="card-title">Sandėliavimas</h2>
                                                <ul>
                                                    <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                                    <li>Kokias paslaugas teikiate?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long
                                                        term contracts. You are free to close your account at any time; all we ask is 30 days notice for
                                                        inventory retrieval.
                                                    </li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Ar teikiate mėnesio ataskaitas?</li>
                                                    <li>Ar priimate grąžinimus iš klientų?</li>
                                                    <li>Kokias papildomas paslaugas teikiate? Prekių žymėjimas lipdukais?</li>
                                                    <li>Ar galite pridėti mano PVM sąskaitą-faktūrą prie užsakymo?</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="card-title">Pristatymo paslaugos</h2>
                                                <ul>
                                                    <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                                    <li>Kokias paslaugas teikiate?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long
                                                        term contracts. You are free to close your account at any time; all we ask is 30 days notice for
                                                        inventory retrieval.
                                                    </li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Ar teikiate mėnesio ataskaitas?</li>
                                                    <li>Ar priimate grąžinimus iš klientų?</li>
                                                    <li>Kokias papildomas paslaugas teikiate? Prekių žymėjimas lipdukais?</li>
                                                    <li>Ar galite pridėti mano PVM sąskaitą-faktūrą prie užsakymo?</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="card-title">Inventorius</h2>
                                                <ul>
                                                    <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                                    <li>Kokias paslaugas teikiate?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long
                                                        term contracts. You are free to close your account at any time; all we ask is 30 days notice for
                                                        inventory retrieval.
                                                    </li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Ar teikiate mėnesio ataskaitas?</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="card-title">Užsakymai</h2>
                                                <ul>
                                                    <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                                    <li>Kokias paslaugas teikiate?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long
                                                        term contracts. You are free to close your account at any time; all we ask is 30 days notice for
                                                        inventory retrieval.
                                                    </li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Ar teikiate mėnesio ataskaitas?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-body">
                                                <h2 class="card-title">Kaina ir apmokėjimas</h2>
                                                <ul>
                                                    <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                                    <li>Kokias paslaugas teikiate?</li>
                                                    <li>Su kokiomis platformomis susieta Boxiti sistema?</li>
                                                    <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                                    <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                                    <li>Ar siūlote ir svetainės API integraciją?</li>
                                                    <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                                        encryption.
                                                    </li>
                                                    <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long
                                                        term contracts. You are free to close your account at any time; all we ask is 30 days notice for
                                                        inventory retrieval.
                                                    </li>
                                                    <li>Kaip pradėti naudotis paslaugomis?</li>
                                                    <li>Ar teikiate mėnesio ataskaitas?</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main><!-- End Main -->
        <footer-component></footer-component>
    </div>

</template>

<script>
    export default {
        name: 'Help',
        metaInfo() {
            return {
                title: this.$t('meta.faq.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.faq.description') },
                ]
            }
        },
    }
</script>

<style lang="scss">
    .content-description {
        padding-bottom: 45px;
        @media (max-width: 575.98px) {
            padding-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Public/Help.vue